import theme from "@/configs/Theme";
import { Paper, Box, styled } from "@mui/material";

interface IProps {
  children: any;
  variant?: "default" | "content-fit";
}

interface CustomBoxProps {
  variant?: "default" | "content-fit";
}

const CustomBox = styled(Box)<CustomBoxProps>(
  ({ theme, variant = "default" }) => ({
    display: "flex",
    flexDirection: "column",
    height: "fit-content",
    backgroundColor:
      variant === "content-fit" ? "transparent" : theme.palette.neutral0.main,
    width: "100%",
    alignItems: "center",

    maxWidth: "100%",

    borderRadius: "16px",
    [theme.breakpoints.down("md")]: {
      padding: "0%",
    },
    [theme.breakpoints.up("xs")]: {
      // height: "fit-content",
      // minHeight: variant === "content-fit" ? "80vh" : "fit-content",
    },
  })
);

export function LargeContentBox({ children, variant = "default" }: IProps) {
  const paperStyles = {
    default: {
      display: "grid",
      width: "100%",
      maxWidth: theme.breakpoints.down("md") ? window.innerWidth - 20 : "100%",
      height: "fit-content",
      padding: 3,
      justifyItems: "center",
      overflowY: "visible",
    },
    "content-fit": {
      display: "grid",
      width: "auto",
      maxWidth: theme.breakpoints.down("md")
        ? window.innerWidth - 20
        : "fit-content",
      height: "fit-content",
      padding: 3,
      justifyItems: "center",
      overflowY: "visible",
    },
  };

  return (
    <CustomBox variant={variant}>
      <Paper sx={paperStyles[variant]}>{children}</Paper>
    </CustomBox>
  );
}
